import { render, staticRenderFns } from "./ShowButton.vue?vue&type=template&id=6070fbaf&"
import script from "./ShowButton.vue?vue&type=script&lang=js&"
export * from "./ShowButton.vue?vue&type=script&lang=js&"
import style0 from "./ShowButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports